import { Box, Typography } from "@mui/material";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";

const EmptyComment = () => {
  return (
    <Box sx={{ padding: "16px", mb: "auto", mt: "48px" }}>
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: "32px",
          fontFamily: "Tahrir",
          lineHeight: "32px",
          mb: "16px",
        }}
      >
        There are no comments posted yet
      </Typography>
      <Typography style={{ fontSize: "18px", color: "gray.main" }}>
        Be the 1st one, Add a comment!
      </Typography>
      <Box style={{ display: "flex", justifyContent: "center" }}>
        <ChatOutlinedIcon
          sx={{
            textAlign: "center",
            color: "#BDBDBD",
            height: "100px",
            width: "100px",
            marginTop: "60px",
          }}
        />
      </Box>
    </Box>
  );
};

export default EmptyComment;
